import React, { useEffect, useState } from 'react';
import './timeslot-picker-lincoln.scss';
import Dropdown from '../../../common/dropdown/dropdown';
import { useOSBStep } from '../../../../hooks/owners-osb';
import { convertMilitaryToMeridiemTime, timeRangeFormat } from '../osb-utils';
import { TimeRange } from '../../../../models/osb-model/dealer-calendar-details';

interface Props {
    data: string[];
    selectedDate: string;
    setSelectedTime?: (time: string) => void;
    setSelectedTimeRange?: (time: string) => void;
    message?: string;
    initSelectTime?: string;
    initSelectTimeRange?: string;
    isMobileView: boolean;
    selectTimeLabel?: string;
    dropDownClickHandler?: () => void;
    hasMobileService?: boolean;
    isMobileServiceSelected?: boolean;
    timeRanges?: string[];
}
export const TimeslotPicker = (props: Props) => {
    const { osbStep } = useOSBStep();
    const [userSelectedTime, setUserSelectedTime] = useState(
        props.initSelectTime && props.initSelectTime?.length > 0
            ? props.initSelectTime
            : props.data[0]
    );
    const [userSelectedTimeRange, setUserSelectedTimeRange] = useState(
        props.initSelectTimeRange && props.initSelectTimeRange?.length > 0
            ? props.initSelectTimeRange
            : props.timeRanges?.[0]
    );

    const selecetedTimeRange = (index: number) => {
        if (props.timeRanges?.[index]) {
            props.setSelectedTimeRange &&
                props.setSelectedTimeRange(props.timeRanges[index]);
            setUserSelectedTimeRange(props.timeRanges[index]);
        }
    };

    useEffect(() => {
        setUserSelectedTime(props.initSelectTime || props.data[0]);
        setUserSelectedTimeRange(
            props.initSelectTimeRange ?? props.timeRanges?.[0] ?? ''
        );
    }, [props.selectedDate]);

    const handleChange = (e: any) => {
        props.setSelectedTime && props.setSelectedTime(e.target.value);
        setUserSelectedTime(e.target.value);
    };
    const postTimeSlots = props.data.map(timeSlot => (
        <span key={timeSlot}>
            <input
                data-testid={`Select ${timeSlot}`}
                type="radio"
                id={timeSlot + '-field'}
                name={timeSlot + '-field'}
                value={timeSlot}
                className="radio-custom"
                checked={userSelectedTime === timeSlot}
                onChange={e => handleChange(e)}
            />
            <label htmlFor={timeSlot + '-field'}>
                {osbStep.twelveHrsTimeFormat
                    ? convertMilitaryToMeridiemTime(
                          timeSlot,
                          osbStep.amTimeLabel,
                          osbStep.pmTimeLabel
                      )
                    : timeSlot}
            </label>
        </span>
    ));

    const correctedTimeRangeFormat = (timeRangesList: TimeRange[]) => {
        const timeRanges: string[] = [];
        for (const range of timeRangesList) {
            timeRanges.push(
                timeRangeFormat(`${range.start}-${range.end}`, osbStep)
            );
        }
        return timeRanges;
    };

    return (
        <div className="osb-timeslot-picker-container">
            {!props.isMobileServiceSelected || !props.hasMobileService ? (
                <>
                    {props.isMobileView && (
                        <div className="main-head">{props.message}</div>
                    )}
                    <div className="timeslot-picker">
                        <div className="radio-toolbar">{postTimeSlots}</div>
                    </div>
                </>
            ) : (
                <>
                    {props.isMobileView && (
                        <div className="time-range-main-head">
                            {props.message}
                        </div>
                    )}
                    <div className="timerange-picker">
                        {props.isMobileView && (
                            <div className="input-label">
                                {props.selectTimeLabel}
                            </div>
                        )}
                        <Dropdown
                            showLabel={false}
                            label={timeRangeFormat(
                                userSelectedTimeRange ?? '',
                                osbStep
                            )}
                            options={correctedTimeRangeFormat(
                                (props.timeRanges || []).map((str: string) => {
                                    const [start, end] = str
                                        .split('-')
                                        .map(s => s.trim());
                                    return { start, end };
                                })
                            )}
                            value={timeRangeFormat(
                                userSelectedTimeRange ?? '',
                                osbStep
                            )}
                            className="osb-dropdown-input"
                            onChange={(_value: string, index: number) =>
                                selecetedTimeRange(index)
                            }
                            onDropdownClick={props.dropDownClickHandler}
                        />
                    </div>
                </>
            )}
        </div>
    );
};
